var _rect, _path, _rect2, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaleRegister(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#0A64F9",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 18,
    height: 7,
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13V7.5h7V13"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 4,
    width: 5.5,
    height: 4.5,
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 8.5V11H13.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.6h3M8.5 11.1h3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.5h4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleRegister);
export default __webpack_public_path__ + "static/media/sale_register.976ccb0a4b3ceaf46ae63fec06b75f07.svg";
export { ForwardRef as ReactComponent };